<template>
	<div class="seller-exit">
		<div class="btnbox">
			<el-button size="small" @click="goStock">在仓库存</el-button>
			<el-button size="small" @click="goList">云仓列表</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in stateList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="apply_no" label="申请单号" align="center" header-align="center" min-width="180px"></el-table-column>
					<el-table-column prop="warehouse_name" label="云仓" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="reason_str" label="原因" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="total_quantity" label="件数" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column label="收货信息" align="center" header-align="center" min-width="180px">
						<template slot-scope="scope">
							<div>{{ scope.row.receiver_name }} {{ scope.row.receiver_mobile }}</div>
							<div class="sub">{{ scope.row.receiver_address }}</div>
						</template>
					</el-table-column>
					<el-table-column label="物流/费用" align="center" header-align="center" min-width="180px">
						<template slot-scope="scope">
							<div v-if="scope.row.state == 2">拒绝：{{ scope.row.audit_remark || '-' }}</div>
							<div v-if="scope.row.shipping_name">{{ scope.row.shipping_name }} {{ scope.row.shipping_tracking_no }}</div>
							<div v-if="scope.row.shipping_time_str">发货：{{ scope.row.shipping_time_str }}</div>
							<div v-if="scope.row.state >= 3">{{ feeText(scope.row) }}</div>
							<div v-if="scope.row.compensate_state_str">结算：{{ scope.row.compensate_state_str }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="申请时间" align="center" header-align="center" width="160px"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="130px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDetail(scope.row)">详情</span>
								<span v-if="scope.row.state == 3" @click="onConfirm(scope.row)">确认收货</span>
								<span v-else-if="scope.row.state == 0">等待审核</span>
								<span v-else-if="scope.row.state == 1">等待发货</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="'取回详情 · ' + (currentDetail.apply_no || '')" :visible.sync="detailShow" width="720px"
			:before-close="closeDetail">
			<div class="detail-box" v-if="detailShow">
				<div class="detail-meta">
					<div><span>云仓</span>{{ currentDetail.warehouse_name || '-' }}</div>
					<div><span>状态</span>{{ currentDetail.state_str || '-' }}</div>
					<div><span>原因</span>{{ currentDetail.reason_str || '-' }}</div>
					<div><span>件数</span>{{ currentDetail.total_quantity || 0 }}</div>
					<div><span>收货人</span>{{ currentDetail.receiver_name }} {{ currentDetail.receiver_mobile }}</div>
					<div><span>地址</span>{{ currentDetail.receiver_address }}</div>
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 2">拒绝：{{ currentDetail.audit_remark || '-' }}</div>
				<div class="detail-extra" v-if="currentDetail.shipping_name">
					物流：{{ currentDetail.shipping_name }} {{ currentDetail.shipping_tracking_no }}
				</div>
				<div class="detail-extra" v-if="currentDetail.state >= 3">{{ feeText(currentDetail) }}</div>
				<div class="detail-extra" v-if="currentDetail.compensate_state_str">费用结算：{{ currentDetail.compensate_state_str }}</div>
				<el-table :data="currentDetail.items || []" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" min-width="120" align="center"></el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
					<el-table-column prop="quantity" label="申请件数" width="90" align="center"></el-table-column>
					<el-table-column label="供货价" width="90" align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.unit_cost) }}</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="currentDetail.state == 3" type="primary" @click="onConfirm(currentDetail)">确认收货</el-button>
				<el-button @click="closeDetail">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseExit',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					state: ''
				},
				stateList: [
					{ id: 0, name: '待审核' },
					{ id: 1, name: '通过' },
					{ id: 2, name: '拒绝' },
					{ id: 3, name: '已发货' },
					{ id: 4, name: '已完成' }
				],
				detailShow: false,
				currentDetail: {},
				queryOpened: false
			}
		},
		mounted() {
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			feeText(row) {
				var parts = []
				if (Number(row.freight_type) === 1) {
					parts.push('到付')
				} else if (row.freight != null) {
					parts.push('运费 ¥' + this.fenToYuan(row.freight))
				}
				if (Number(row.compensation || 0) > 0) {
					parts.push('补偿 ¥' + this.fenToYuan(row.compensation))
				}
				return parts.join(' · ')
			},
			goStock() {
				this.$router.push('/seller/warehouse/stock')
			},
			goList() {
				this.$router.push('/seller/warehouse/index')
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter.state = ''
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			openDetail(row) {
				this.currentDetail = row || {}
				this.detailShow = true
			},
			closeDetail() {
				this.detailShow = false
				this.currentDetail = {}
			},
			tryOpenQuery() {
				var no = this.$route.query.apply_no
				if (!no || this.queryOpened) {
					return
				}
				var row = this.list.filter(function(item) {
					return String(item.apply_no) === String(no)
				})[0]
				if (row) {
					this.queryOpened = true
					this.openDetail(row)
				}
			},
			onConfirm(row) {
				var self = this
				this.$confirm('确认已收到退回商品？确认后将按实际在仓数量完成退仓并释放冻结。', '确认收货', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function() {
					self.$axios.post('api/cloud_warehouse/exit_confirm', {
						apply_no: row.apply_no
					}).then(function(res) {
						if (res.data.code === 0) {
							var data = res.data.data || {}
							self.$message.success('已确认收货，释放冻结 ¥' + self.fenToYuan(data.total_release))
							self.closeDetail()
							self.onlist()
						} else {
							self.$message.error(apiMsg(res))
						}
					}).catch(function(err) {
						console.log(err)
					})
				}).catch(function() {})
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize,
					role: 'seller'
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/exit_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
						this.tryOpenQuery()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-exit {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.sub {
		color: #909399;
		font-size: 12px;
	}

	.state-0 {
		color: #E6A23C;
	}
	.state-1,
	.state-3 {
		color: #409EFF;
	}
	.state-2 {
		color: #F56C6C;
	}
	.state-4 {
		color: #67C23A;
	}

	.detail-meta {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		div {
			width: 50%;
			line-height: 26px;
			box-sizing: border-box;
			padding-right: 12px;
			span {
				display: inline-block;
				width: 56px;
				color: #909399;
			}
		}
	}

	.detail-extra {
		margin-bottom: 8px;
		color: #606266;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/exit.vue